import { useFlags } from "launchdarkly-react-client-sdk";
import { useEffect } from "react";

import { BE_API_URLS_FLAG } from "constants/feature-flags";
import { updateApiConfigFromFeatureFlag } from "utils/api-config.util";

/**
 * Hook to monitor beApiUrls feature flag and update API configuration
 * This ensures that API calls are dynamically routed to the correct environment
 */
export const useApiConfig = () => {
  const flags = useFlags();
  const beApiUrls = flags[BE_API_URLS_FLAG];

  useEffect(() => {
    // Update API configuration whenever the feature flag changes
    updateApiConfigFromFeatureFlag(beApiUrls);
  }, [beApiUrls]);

  return {
    currentApiUrls: beApiUrls,
    hasCustomUrls: Boolean(beApiUrls?.api_url || beApiUrls?.ws_url)
  };
};
